import store from "../../../store";
import {getDeimpersonatedTokens} from "../repository/ChangeUserRepository";
import {logInToApplicationByToken} from "../../../services/ApplicationService";
import router from "../../../core/router";

export default {
    beforeRouteEnter() {
        let contextApp = store.state.context.app;
        let continueUrl = store.state.context.continueUrl;

        getDeimpersonatedTokens(contextApp.uuid)
            .then(({data}) => {
                store.dispatch('Auth/onValidTokenReceived', data.contextToken)
                    .then(() => logInToApplicationByToken(contextApp, continueUrl, data.requestedToken));
            })
            .catch(() => router.push({name: 'Dashboard'}));
    }
}